import { z } from "zod";
import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL_ID,
  MOBILE_NO,
  ADDRESS,
  STATE,
  CITY,
  ZIPCODE,
  TEMP_PASSWORD,
  COUNTRY,
  FORCE_PASSWORD,
} from "./consts";

export const schema = z.object({
  [FIRST_NAME]: z.string().min(2, "This field is required"),
  [LAST_NAME]: z.string().min(2, "This field is required"),
  [EMAIL_ID]: z
    .string()
    .min(1, "This field is required")
    .email("This is not a valid email."),
  [MOBILE_NO]: z.string().min(10, "This field is required"),
  [TEMP_PASSWORD]: z.string().optional(),
  [FORCE_PASSWORD]: z.boolean().optional(),
  [ADDRESS]: z.string().min(1, "This field is required"),
  [STATE]: z.string().min(1, "This field is required"),
  [COUNTRY]: z.string().optional(),
  [CITY]: z.string().min(1, "This field is required"),
  [ZIPCODE]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
